import type { ReactNode } from 'react';
import { Landscape } from './Landscape';
import './MobileLandscapeBackground.css';

/** Shared landscape for full-screen mobile pages that cover the regular app shell. */
export function MobileLandscapeBackground({
  fixed = false,
  clear = false,
  foreground,
  overlay,
  parallax = true,
}: {
  fixed?: boolean;
  clear?: boolean;
  foreground?: ReactNode;
  overlay?: ReactNode;
  parallax?: boolean;
}) {
  return (
    <div
      className={`mobile-landscape-background${fixed ? ' mobile-landscape-background--fixed' : ''}${clear ? ' mobile-landscape-background--clear' : ''}`}
      aria-hidden={foreground || overlay ? undefined : true}
    >
      <Landscape
        parallax={parallax}
        appearance={clear ? 'clear' : 'soft'}
        foreground={foreground}
        overlay={overlay}
      />
    </div>
  );
}
